import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';
import { Navbar, Nav, Container, Button, Form, FormControl, Dropdown } from 'react-bootstrap';
import { FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import { LoginModal } from '../admin/AuthModals';
import 'bootstrap/dist/css/bootstrap.min.css';

const PAGES = [
  { path: '/', title: 'Главная' },
  { path: '/about', title: 'О нас' },
  { path: '/news', title: 'Новости' },
  { path: '/alumni', title: 'Выпускники' },
  { path: '/career', title: 'Карьера' },
  { path: '/partners', title: 'Партнеры' },
  { path: '/find-alumni', title: 'Найти выпускников' },
  { path: '/donate', title: 'Пожертвовать' },
  { path: '/success-stories', title: 'История успеха' },
  { path: '/contact', title: 'Контакты' },
];

const Header = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    loadUserData();
  }, []);

  const loadUserData = () => {
    const token = localStorage.getItem('adminToken') || localStorage.getItem('token');
    const savedUser = localStorage.getItem('adminUser');
    
    if (token && savedUser) {
      try {
        const user = JSON.parse(savedUser);
        setUserData(user);
      } catch (e) {
        console.error('Ошибка парсинга:', e);
        setUserData(null);
      }
    } else {
      setUserData(null);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    localStorage.removeItem('token');
    setUserData(null);
    navigate('/');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const result = PAGES.find(p => p.title.toLowerCase().includes(searchQuery.toLowerCase()));
      if (result) navigate(result.path);
      setSearchQuery('');
      setExpanded(false);
    }
  };

  const handleLoginSuccess = (token, userData) => {
    setUserData(userData);
    setShowLoginModal(false);
    
    if (userData.role === 'admin') {
      navigate('/admin');
    } else {
      navigate('/profile');
    }
  };

  const goToProfile = () => {
    if (userData) {
      if (userData.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/profile');
      }
    } else {
      setShowLoginModal(true);
    }
  };

  return (
    <>
      <div className="top-bar">
        <Container className="d-flex justify-content-between align-items-center py-2">
          <div className="d-flex align-items-center">
            <Link to="/" className="brand-logo d-flex align-items-center text-decoration-none">
              <img src="/logo_oshtuu.png" alt="Logo" className="brand-img me-2" style={{ height: '50px' }} />
              <div className="brand-text">
                <span>Ошский</span>
                <span>Технологический Университет</span>
              </div>
            </Link>
          </div>

          <div className="icon-group d-flex align-items-center gap-3">
            {/* Поиск */}
            <Form onSubmit={handleSearch} className="desktop-search">
              <FormControl
                type="search"
                placeholder="Поиск..."
                size="sm"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ width: '200px' }}
              />
            </Form>

            {/* Кнопка пожертвования */}
            <Button as={Link} to="/donate" className="donate-btn">
              Поддержать ассоциацию
            </Button>

            {/* Десктопная авторизация */}
            <div className="desktop-auth">
              {!userData ? (
                <div className="d-flex gap-2">
                  <Button variant="link" onClick={() => setShowLoginModal(true)} className="text-decoration-none" style={{ color: '#006186' }}>
                    Вход
                  </Button>
                  <span style={{ color: '#006186' }}>|</span>
                  <Button variant="link" as={Link} to="/register" className="text-decoration-none" style={{ color: '#006186' }}>
                    Регистрация
                  </Button>
                </div>
              ) : (
                <Dropdown align="end">
                  <Dropdown.Toggle variant="link" id="dropdown-user" className="p-0 text-decoration-none">
                    <FaUserCircle size={28} style={{ color: '#006186' }} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item disabled>
                      <strong>{userData.fio || userData.email}</strong>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={goToProfile}>
                      {userData.role === 'admin' ? 'Админ-панель' : 'Мой профиль'}
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout} className="text-danger">
                      <FaSignOutAlt className="me-2" /> Выйти
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>

            {/* Бургер-меню */}
            <Navbar.Toggle
              aria-controls="main-navbar-nav"
              className="custom-toggle"
              onClick={() => setExpanded(!expanded)}
            />
          </div>
        </Container>
      </div>

      <Navbar expanded={expanded} expand="lg" className="main-navbar p-0">
        <Container>
          <Navbar.Collapse id="main-navbar-nav">
            <Nav className="mx-auto">
              {PAGES.map((page) => (
                <Nav.Link key={page.path} as={Link} to={page.path} onClick={() => setExpanded(false)}>
                  {page.title}
                </Nav.Link>
              ))}
            </Nav>
            
            {/* Мобильный поиск */}
            <Form onSubmit={handleSearch} className="mobile-search mt-3">
              <FormControl
                type="search"
                placeholder="Поиск..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </Form>
            
            {/* Мобильная кнопка пожертвования */}
            <div className="mobile-donate mt-3">
              <Button as={Link} to="/donate" onClick={() => setExpanded(false)} className="donate-btn w-100">
                Поддержать ассоциацию
              </Button>
            </div>
            
            {/* Мобильная авторизация */}
            <div className="mobile-auth-section mt-3">
              {!userData ? (
                <div className="mobile-auth-buttons">
                  <Button 
                    variant="outline-primary" 
                    onClick={() => { setShowLoginModal(true); setExpanded(false); }} 
                    className="w-100 mb-2"
                  >
                    Вход
                  </Button>
                  <Button 
                    variant="outline-primary" 
                    as={Link} 
                    to="/register" 
                    onClick={() => setExpanded(false)} 
                    className="w-100"
                  >
                    Регистрация
                  </Button>
                </div>
              ) : (
                <div className="mobile-user-info">
                  <div className="mobile-user-name text-center mb-3">
                    <FaUserCircle size={40} style={{ color: '#006186' }} />
                    <p className="mt-2 mb-0 fw-bold">{userData.fio || userData.email}</p>
                  </div>
                  <Button 
                    variant="outline-primary" 
                    onClick={goToProfile} 
                    className="w-100 mb-2"
                  >
                    {userData.role === 'admin' ? 'Админ-панель' : 'Мой профиль'}
                  </Button>
                  <Button 
                    variant="outline-danger" 
                    onClick={handleLogout} 
                    className="w-100"
                  >
                    <FaSignOutAlt className="me-2" /> Выйти
                  </Button>
                </div>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <LoginModal 
        show={showLoginModal} 
        onHide={() => setShowLoginModal(false)}
        onSwitchToForgotPassword={() => {
          setShowLoginModal(false);
          navigate('/forgot-password');
        }}
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  );
};

export default Header;